<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 基础表格
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <!-- <el-input
          v-model="query.keyWord"
          placeholder="分类名"
          class="handle-input mr10"
        ></el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
        >搜索</el-button> -->
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="addVisible=true"
        >增加</el-button>
      </div>
      <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="id"
          label="ID"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="名字"
        ></el-table-column>
        <!-- <el-table-column
          prop="status"
          label="状态"
        ></el-table-column> -->
        <el-table-column
          prop="remark"
          label="备注"
        ></el-table-column>
        <el-table-column
          label="操作"
          width="200"
          align="center"
        >
          <template #default="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button>
            <!-- <el-button
              type="text"
              icon="el-icon-user"
              @click="handleBindUser(scope.$index, scope.row)"
            >绑定账号权限</el-button> -->
            <el-button
              type="text"
              icon="el-icon-delete"
              class="red"
              @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="query.pageIndex"
          :page-size="query.pageSize"
          :total="pageTotal"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <!-- 绑定用户弹出框 -->
    <el-dialog
      title="绑定权限"
      v-model="bindUserVisible"
      width="30%"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="70px"
      >
        <el-form-item label="名称">
          <el-select
            v-model="bindUserForm.user_id"
            placeholder="请选择账号"
          >
            <el-option
              v-for="(item,index) in userList"
              :label="item.username"
              :value="item.id"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="bindUserVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="saveAdd"
          >确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 增加弹出框 -->
    <el-dialog
      title="新增角色"
      v-model="addVisible"
      width="30%"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="70px"
      >
        <el-form-item label="名称">
          <el-input v-model="newform.name"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="addVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="saveAdd"
          >确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 编辑弹出框 -->
    <el-dialog
      title="编辑"
      v-model="editVisible"
      width="30%"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="70px"
      >
        <el-form-item label="名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item
          v-for="(item,index) in updateMenu"
          :key="index"
          :label="item.name"
        >
          <el-checkbox
            v-model="_item.selected"
            v-for="(_item,_index) in item.children"
            :key="_index"
            :label="_item.name"
          ></el-checkbox>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="saveEdit"
          >确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api/index";
import { reactive } from "vue";
let gMenu;
export default {
  name: "basetable",
  data() {
    return {
      query: {
        address: "",
        name: "",
        keyWord: "",
        pageIndex: 1,
        pageSize: 20,
      }, //查询的参数
      bindUserForm: {}, //绑定用户表单
      userList: [], //用户的列表
      menu: [],
      tableData: [],
      multipleSelection: [],
      delList: [],
      editVisible: false, //编辑用户
      addVisible: false, //增加用户
      bindUserVisible: false, //绑定用户
      pageTotal: 0,
      form: {},
      newform: {},
      idx: -1,
      id: -1,
    };
  },
  created() {
    this.getPage();
    this.getMenu();
    // this.getUserList();
  },
  computed: {
    newMenu() {
      let menu = JSON.parse(JSON.stringify(gMenu));
      return reactive(menu);
    },
    updateMenu() {
      let menu = JSON.parse(JSON.stringify(gMenu));
      return reactive(menu);
    },
  },
  methods: {
    //获取用户的列表
    getUserList() {
      api
        .manageList({
          per_page: 100,
          page: 1,
        })
        .then((res) => {
          this.userList = res.data.data;
        });
    },
    //绑定用户的
    handleBindUser() {
      this.bindUserVisible = true;
    },
    //获取菜单
    getMenu() {
      api.rbacMenu().then((res) => {
        this.menu = res.data;
        gMenu = res.data;
        console.log(gMenu);
        // let menuTree = []
        // res.data.forEach(item=>{

        // })
      });
    },
    //保存新增
    saveAdd() {
      api
        .rbacRoleAdd({
          name: this.newform.name,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("成功添加");
            this.getPage();
          }
        });
      this.addVisible = false;
    },
    // 获取 easy-mock 的模拟数据
    getPage() {
      let data = {
        per_page: this.query.pageSize,
        page: this.query.pageIndex,
      };
      if (this.query.keyWord) {
        data.keyword = this.query.keyWord;
      }
      api.rbacRole(data).then((res) => {
        console.log(res);
        this.tableData = res.data;
        this.pageTotal = res.data.total || 50;
      });
    },
    // 触发搜索按钮
    handleSearch() {
      this.query.pageIndex = 1;
      this.getPage();
    },
    // 删除操作
    handleDelete(index, row) {
      // 二次确认删除

      this.$confirm("确定要删除吗？", "提示", {
        type: "warning",
      })
        .then((res) => {
          console.log("tag", res);
          api
            .rbacRoleDelete({
              id: row.id,
            })
            .then((result) => {
              if (result.code === 200) {
                this.$message.success("删除成功");
                this.getPage();
              }
            });
        })
        .catch(() => {});
    },
    // 多选操作
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delAllSelection() {
      const length = this.multipleSelection.length;
      let str = "";
      this.delList = this.delList.concat(this.multipleSelection);
      for (let i = 0; i < length; i++) {
        str += this.multipleSelection[i].name + " ";
      }
      this.$message.error(`删除了${str}`);
      this.multipleSelection = [];
    },
    // 编辑操作
    handleEdit(index, row) {
      this.idx = row.id;
      this.form = row;
      this.editVisible = true;
      //   let menu = JSON.parse(JSON.stringify(gMenu));
      //重置全部的选中
      this.updateMenu.forEach((el, i) => {
        this.updateMenu[i].children.forEach((element, index) => {
          this.updateMenu[i].children[index].selected = false;
        });
      });
      api
        .rbacAuthorize({
          id: this.idx,
        })
        .then((res) => {
          if (res.data == "" || res.data.length == 0) {
            return;
          } else {
            //把获取到的权限选中
            this.updateMenu.forEach((el, i) => {
              this.updateMenu[i].children.forEach((element, index) => {
                //通过是否存在这个属性来判断
                this.updateMenu[i].children[index].selected = res.data[
                  element.id
                ]
                  ? true
                  : false;
              });
            });
          }
        });
    },
    // 保存编辑
    saveEdit() {
      let menuId = [];
      this.updateMenu.forEach((el) => {
        el.children.forEach((element) => {
          if (element.selected) {
            console.log(menuId);
            menuId.push(element.id);
          }
        });
      });
      console.log(this.updateMenu);

      api
        .rbacRoleEdit({
          id: this.idx,
          name: this.form.name,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(`修改名字成功`);
            this.getPage();
          }
        });

      api
        .rbacAuthorizeEdit({
          id: this.idx,
          menuid: menuId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(`修改权限成功`);
         
          }
        });

      this.editVisible = false;
    },
    // 分页导航
    handlePageChange(val) {
      this.query.pageIndex = val;
      this.getPage();
    },
  },
};
</script>

<style lang="scss" scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}
</style>
